export default __webpack_public_path__ + "static/media/054-orangutan.68e09835.svg";